export const moreText = () => {
	$(".js-more-text").on("click", e => {
		const element = $(e.currentTarget);
		if (element.find("span").text().trim() === "Подробнее") {
			element.parents(".js-short-text").removeClass("short");
			element.find("span").text("Скрыть");
		} else {
			element.parents(".js-short-text").addClass("short");
			element.find("span").text("Подробнее");
		}
	});
};
